export function useSign(val, iconSize, iconStyle, classNameSuffix, titleSuffix) {
    const iconClassName = `${iconStyle || 'far'} ${iconSize || 'fa-xs'}`;
    const prefix = (val > 0) ? '+' : undefined;
    const title = (val !== undefined) ? `${prefix || ''}${val.toFixed(2)}${titleSuffix || ''}` : undefined;
    if (val > 0) {
        return [val, { className: `pos${classNameSuffix || ''}`, title, prefix, icon: `${iconClassName} fa-triangle` }];
    }
    if (val < 0) {
        return [val, { className: `neg${classNameSuffix || ''}`, title, prefix, icon: `${iconClassName} fa-triangle fa-flip-vertical` }];
    }
    return [val, {}];
}
//# sourceMappingURL=useSign.js.map